/* eslint-disable */
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class SessionStorageService {
  public set(key: string, value: any) {
    sessionStorage.setItem(key, JSON.stringify(value));
  }

  public get(key: string) {
    if (!sessionStorage.getItem(key)) {
      return null;
    }
    let data: any = sessionStorage.getItem(key);
    return JSON.parse(data);
  }

  public remove(key: string) {
    sessionStorage.removeItem(key);
  }
}
